module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "persistent": ""
    },
    model: {
      value: (_vm.showDlg),
      callback: function($$v) {
        _vm.showDlg = $$v
      },
      expression: "showDlg"
    }
  }, [_c('div', {
    staticClass: "primary white--text pa-3 title"
  }, [(_vm.isNewComm) ? _c('span', [_vm._v("New community creation")]) : _c('span', [_vm._v("Joining to " + _vm._s(_vm.commNm))])]), _vm._v(" "), _c('v-stepper', {
    model: {
      value: (_vm.curStep),
      callback: function($$v) {
        _vm.curStep = _vm._n($$v)
      },
      expression: "curStep"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.curStep > 1
    }
  }, [_vm._v("Mobile validation")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.curStep > 2
    }
  }, [_vm._v("Personal details")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.curStep > 3
    }
  }, [_vm._v(_vm._s(_vm.isNewComm ? 'Community details' : 'Unit details'))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "4"
    }
  }, [_vm._v("Done")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-0"
  }, [_vm._v("Mobile validation")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-form', {
    ref: "form1"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "",
      "placeholder": "Enter a mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      }
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace($event)
      }
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("\n                          Enter your mobile number and press send OTP\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(_vm.secToWait > 0) ? _c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("Wait " + _vm._s(_vm.secToWait) + " sec to retry")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 pa-0 accent--text",
    attrs: {
      "flat": "",
      "disabled": (!_vm.canResend && !_vm.isValidNumber) || _vm.secToWait > 0
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("\n                          " + _vm._s((_vm.canResend ? 'Resend' : 'Send') + ' OTP') + "\n                        ")])], 1)], 1), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP",
      "hide-details": ""
    },
    model: {
      value: (_vm.otp),
      callback: function($$v) {
        _vm.otp = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "otp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                      By clicking continue, you agree to our "), _c('a', {
    staticClass: "info--text",
    on: {
      "click": function($event) {
        _vm.showTerms = true
      }
    }
  }, [_vm._v("terms & conditions and privacy policy")])]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-0"
  }, [_vm._v("Personal details")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-form', {
    ref: "form2"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.isHavingHistory) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "mt-0",
    attrs: {
      "color": "warning",
      "value": "true"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n                            You already have below accounts with us, continue if you wish to join another unit.\n                          ")]), _vm._v(" "), _vm._l((_vm.userHistory), function(unit, u) {
    return _c('div', {
      key: u,
      staticClass: "primary--text"
    }, [(unit.unit_no) ? _c('span', [_vm._v("\n                              " + _vm._s(u + 1 + '. ' + unit.block_nm + ' ' + unit.unit_no + ' in ' + unit.comm_name) + "\n                            ")]) : (unit.comm_name) ? _c('span', [_vm._v("\n                              " + _vm._s(unit.role_name + ' in ' + unit.comm_name) + "\n                            ")]) : _vm._e()])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Your name",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": ['Male', 'Female'],
      "placeholder": "Gender",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "E-mail address",
      "rules": [_vm.rules.required, _vm.rules.email],
      "maxlength": "50"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Hide contact info from others",
      "disabled": _vm.mcOrOthers !== 'resident',
      "hint": "Not possible if you are part of association or staff ;)",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.hideContact),
      callback: function($$v) {
        _vm.hideContact = $$v
      },
      expression: "hideContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: (_vm.mcOrOthers),
      callback: function($$v) {
        _vm.mcOrOthers = $$v
      },
      expression: "mcOrOthers"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Resident (owner/tenant)",
      "value": "resident"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": (_vm.commCountryCode === 'MY' ? 'JMB' : 'Association') + '/MC member',
      "value": "mc-member"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Staff",
      "value": "staff"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Others",
      "value": "other-user"
    }
  })], 1)], 1), _vm._v(" "), (_vm.mcOrOthers !== 'resident') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Role",
      "items": _vm.mcOrOthers === 'mc-member' ? _vm.mcRolesList : (_vm.mcOrOthers === 'staff' ? _vm.staffRolesList : _vm.othersRolesList),
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.isNewComm) ? _c('v-card-title', {
    staticClass: "title pt-0"
  }, [_vm._v("Community details")]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-form', {
    ref: "form3"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(!_vm.isNewComm) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "title accent white--text pa-2",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("location_city")]), _vm._v("\n                    " + _vm._s(_vm.commNm) + "\n                  ")], 1)], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "refCommName",
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Community name",
      "rules": [_vm.rules.required],
      "hint": "New community will be created with this name",
      "persistent-hint": "",
      "maxlength": "50"
    },
    on: {
      "blur": _vm.checkDupComm
    },
    model: {
      value: (_vm.commNm),
      callback: function($$v) {
        _vm.commNm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commNm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Address",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.commAdr),
      callback: function($$v) {
        _vm.commAdr = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commAdr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "City",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.commCity),
      callback: function($$v) {
        _vm.commCity = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commCity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "PIN",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.commPIN),
      callback: function($$v) {
        _vm.commPIN = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commPIN"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "State",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.commState),
      callback: function($$v) {
        _vm.commState = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commState"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.config.SUPPORTED_COUNTRIES.map(function (rec) { return rec.country; }),
      "placeholder": "Country",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.commCountry),
      callback: function($$v) {
        _vm.commCountry = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commCountry"
    }
  })], 1)], 1), _vm._v(" "), (_vm.mcOrOthers !== 'staff' && _vm.mcOrOthers !== 'other-user') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "title pt-4 pb-2"
  }, [_vm._v("Unit details")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "placeholder": "Block",
      "items": _vm.blockList,
      "rules": [_vm.rules.required],
      "maxlength": "25",
      "disabled": _vm.cantChangeUnit
    },
    on: {
      "input": function($event) {
        return _vm.findBlockId()
      }
    },
    model: {
      value: (_vm.blockNm),
      callback: function($$v) {
        _vm.blockNm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "blockNm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "placeholder": "Unit no.",
      "rules": [_vm.rules.required],
      "items": _vm.unitList,
      "maxlength": "10",
      "disabled": _vm.cantChangeUnit
    },
    on: {
      "input": function($event) {
        return _vm.findUnitId()
      }
    },
    model: {
      value: (_vm.unitNo),
      callback: function($$v) {
        _vm.unitNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "unitNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.resRolesList,
      "placeholder": "Ownership",
      "rules": [_vm.rules.required],
      "disabled": _vm.cantChangeUnit
    },
    model: {
      value: (_vm.ownership),
      callback: function($$v) {
        _vm.ownership = $$v
      },
      expression: "ownership"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "primary"
    }
  }, [_vm._v("auto_awesome")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Congrats!"), _c('br'), _vm._v("You are now part of"), _c('br')]), _vm._v(" "), _c('v-chip', {
    staticClass: "title accent white--text pa-2",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("location_city")]), _vm._v("\n      " + _vm._s(_vm.commNm) + "\n    ")], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-3 pa-1 text-xs-center",
    attrs: {
      "outline": "",
      "color": "info",
      "value": true
    }
  }, [(_vm.isVerResident && !_vm.isAdmin) ? _c('span', [_vm._v("Your resident identity verified successfully. You can start using the app right away!")]) : (!_vm.isAdmin) ? _c('span', [_vm._v("You will be notified as soon as your community admin accepts your request")]) : _c('span', [_vm._v("\n        IMPORTANT\n        "), _c('br'), _c('br'), _vm._v("\n        As your community is just beginning to grow up in Uniservice, you will be one of 3 admins until a committee takes it over.\n        "), _c('br'), _c('br'), _vm._v("\n        Till then, you will be notified to approve whenever other users wish to join your community.\n      ")])])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0 primary"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [(_vm.curStep > 1 && _vm.curStep < 4) ? _c('v-btn', {
    staticClass: "text-xs-left white--text",
    attrs: {
      "flat": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prevStep($event)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.curStep < 4) ? _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDlg($event)
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.curStep == 4) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDlg($event)
      }
    }
  }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), (_vm.curStep < 4) ? _c('v-btn', {
    staticClass: "text-xs-right accent--text",
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextStep($event)
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.butCap))])]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSimComm),
      callback: function($$v) {
        _vm.showSimComm = $$v
      },
      expression: "showSimComm"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Wait!\n    ")]), _vm._v(" "), _c('v-card-text', [_c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.similarCommList.length > 1 ? 'Communities' : 'Community') + " with similar name already found."), _c('br'), _c('br'), _vm._v("Please tap on your community listed below or tap on OVERRIDE to proceed with the name you entered.")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.commNameHead,
      "items": _vm.similarCommList,
      "disable-initial-sort": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.chooseComm(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', {
          staticClass: "title info--text"
        }, [_vm._v(_vm._s(props.item.comm_name))])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSimComm = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSimComm = false
      }
    }
  }, [_vm._v("Overide & Use I Entered")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showTerms),
      callback: function($$v) {
        _vm.showTerms = $$v
      },
      expression: "showTerms"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Terms & Conditions and Privacy Policy\n      "), _c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "top": "7px",
      "right": "7px"
    },
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTerms = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        WHAT INFORMATION WE COLLECT\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "ml-3"
  }, [_c('li', [_vm._v("\n          Details about your society like name, address, number of blocks, flats and facilities.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Personal information like name and contact details of management committee and residents.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Personal information like name and contact number of visitors as a security measure of your society.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Any other information which users share on their sole discretion while creating Invites/EasyPasses, posting notices, posts, comments, replies and complaints, etc.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Invoice and payment details of maintenance & amenity booking charges. We do NOT store users' bank or card details.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        WHAT DO WE USE YOUR INFORMATION FOR\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "ml-3"
  }, [_c('li', [_vm._v("\n          We (“Uniservice”) do NOT sell, rent or share any information collected above to any of our partners and/or third party, without your explicit approval.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          All information is protected with most care using stringent access control and encryption technologies both at transit and storage.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          The information we collect will be used only to provide you better and uninterrupted service by monitoring the usage & performance of the application, identify the gaps and improve our quality of service. Also by our support personal to review and respond to your tickets if any.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        YOUR RIGHT ON YOUR DATA\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n        You can have all your personal information deleted from our systems if you are no longer associated to your society, with an intimation/permission of respective resident welfare association. Please contact us at postman@uniservice.in whenever you want to do so.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        YOUR CONSENT\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n        By using our application, you consent to this privacy policy and terms & conditions.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        NOTIFICATION OF CHANGES\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Any change made to these terms will be notified via E-mail and/or while logging in to application.\n      ")])])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-7f425fc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JoinComm.vue
// module id = 719
// module chunks = 29